export default {
  // meta / table
  Name: "Nom",
  Description: "Description",
  "Business ID": "ID Entreprise",
  "Shop ID": "ID Magasin",
  "Created At": "Créé le",
  "Updated At": "Mis à jour le",
  Actions: "Actions",
  Categories: "Categories",
  "Add a category": "Ajouter une catégorie",

  // form
  Image: "Image",
  "Create a new category": "Créer une nouvelle catégorie",
  "Edit Category": "Modifier la catégorie",

  // view blocks
  "General Informations": "Informations Générales",
  "Metadata & Timestamps": "Métadonnées et Horodatages",
  Category: "Catégorie",
  "Total Sold": "Total vendu",
  "Edit Selection": "Modifier la sélection",
  "Search category by name or description":
    "Rechercher une catégorie par nom ou description",
  "No categories found": "Aucune catégorie trouvée",
  "Do you really want to delete this Category?":
    "Voulez-vous vraiment supprimer cette catégorie ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Attention : cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",
};
